export const SET_FORECAST_MAINTENANCE_AND_GROWTH_CAPEX = "SET_FORECAST_MAINTENANCE_AND_GROWTH_CAPEX"